<template>
	<div class="d-flex align-start justify-space-between">
		<v-menu
			v-model="menuOpen" bottom offset-y :close-on-content-click="false" content-class="contract-annulation-info-container">
			<template v-slot:activator="{ on, attrs }">
				<div
						class="d-flex align-center justify-start"
						v-bind="attrs"
						v-on="on">
					<v-icon
						icon
						dark
						class="ml-1"
						size="20"
						:color="color">mdi-information-box-outline</v-icon>

					<div v-if="finalHistory.type != 1 && finalHistory.status == 1" class="ml-1">
						<v-chip
							:color="color"
							label
							outlined
							x-small>
							<p class="mb-0 font-weight-bold">{{ finalStatus.text }}</p>
						</v-chip>
					</div>
				</div>
			</template>
			<div style="color: black;width: 380px;">
				<div class="d-flex align-center justify-space-between">
					<p class="mb-0 font-weight-bold caption">Historial de Suspensión</p>
					<div>
						<v-chip
							:color="color"
							label
							outlined
							x-small>
							<p class="mb-0 font-weight-bold">{{ finalStatus.text }}</p>
						</v-chip>
					</div>
				</div>
				<v-divider class="my-2"></v-divider>
				<div>
					<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
						<v-list-item dense class="mb-0 px-0" v-for="(history, index) in interactionsHistory" :key="'kk' + index">
							<div class="d-flex flex-column flex-1 mb-2">
								<div>
									<div class="d-flex justify-space-between align-start">
										<div>
											<v-chip
												color="grey"
												label
												outlined
												x-small>
												<div class="d-flex align-center justify-center">
													<p class="mb-0 mr-1">Tipo: <b>{{history.type == 1 ? 'Suspensión':'Restauración'}}</b></p>
													<div style="height: 7px;width: 7px; border-radius: 7px;opacity: 0.7;" :style="history.type == 1 ? 'background-color: #FF1209;':'background-color: green;'"></div>
												</div>
											</v-chip>
											<div class="d-flex align-center justify-start" style="gap: 8px;">
												<v-avatar size="30">
													<img :src="history?.user?.profile?.avatar" v-if="history?.user?.profile?.avatar"/>
													<v-icon v-else small color="#524D4D">mdi-account</v-icon>
												</v-avatar>
												<div>
													<p class="mb-0 caption font-weight-bold">{{ getUserName(history) }}</p>
													<p class="mb-0 text--disabled" style="font-size: 11px;">{{ history?.user?.email }}</p>
												</div>
											</div>
										</div>
										<div>
											<p class="mb-0 text-right text--disabled" style="font-size: 10px;">Fecha y Hora</p>
											<p class="mb-0 caption font-weight-bold	text-right">{{ history.created_at | toDateTime }}</p>
											<v-chip
												:color="getHistoryStatus(history).color"
												label
												outlined
												x-small
												class="px-1 text-center d-flex justify-center"
												style="width: 100%;"
											>
												<b>{{ getHistoryStatus(history).text }}</b>
											</v-chip>
										</div>
									</div>
									<div v-if="history?.observation || history?.comment" style="background-color: #f5f5f5;border-radius: 10px;padding: 3px 10px;border: 1px solid #b6b6b6;margin-top: 5px;">
										<p class="mb-0 text--disabled" style="font-size: 10px;">Motivo / Comentario:</p>
										<p
											class="mb-0 caption"
											style="overflow-wrap: break-word; word-break: break-word; min-width: 0;"
										>{{ history.observation || history?.comment }}</p>
									</div>
								</div>
								<v-divider class="mt-2" v-if="index < (interactionsHistory.length - 1)"></v-divider>
							</div>
						</v-list-item>
					</v-list>
				</div>
			</div>
		</v-menu>
	</div>
</template>

<script>
export default {
	name: 'ContractAnnulationInfo',
	props: {
		contract: {
			type: Object,
			required: true
		},
		color: {
			type: String,
			required: false,
			default: 'black'
		}
	},
	components: {
	},
	data() {
		return {
			menuOpen: false,
			requiredRule: [
				v => !!v || 'Campo requerido'
			]
		};
	},
	computed: {
		finalHistory(){
			return this.interactionsHistory[0]
		},
		finalStatus(){
			const history = this.interactionsHistory[0]
			if(history.type == 1){
				if(history.status === 0){
					return {
						text: 'Solicitud de Suspensión',
						color: 'warning'
					}
				}
				else if(history.status === 1){
					return {
						text: 'Suspendido',
						color: '#FF1209'
					}
				}
				else if(history.status === 2){
					return {
						text: 'Suspensión Rechazada',
						color: 'grey'
					}
				}
				return {
					text: 'Otro',
					color: 'grey'
				}
			}
			else {
				if(history.status === 0){
					return {
						text: 'Solicitud de Restauración',
						color: 'warning'
					}
				}
				else if(history.status === 1){
					return {
						text: 'Restaurado',
						color: 'warning'
					}
				}
				else if(history.status === 2){
					return {
						text: 'Restauración Rechazada',
						color: '#FF1209'
					}
				}
				return {
					text: 'Otro',
					color: 'grey'
				}
			}
		},
		interactionsHistory(){
			return this.contract.status_requests
		}
	},
	mounted() {
	},
	methods: {
		getHistoryStatus(history){
			if(history.type == 1){
				if(history.status === 0){
					return {
						text: 'Solicitado',
						color: 'warning'
					}
				}
				else if(history.status === 1){
					return {
						text: 'Suspendido',
						color: '#FF1209'
					}
				}
				else if(history.status === 2){
					return {
						text: 'Rechazada',
						color: 'grey'
					}
				}
				return {
					text: 'Otro',
					color: 'grey'
				}
			}
			else {
				if(history.status === 0){
					return {
						text: 'Solicitado',
						color: 'warning'
					}
				}
				else if(history.status === 1){
					return {
						text: 'Restaurado',
						color: 'success'
					}
				}
				else if(history.status === 2){
					return {
						text: 'Rechazada',
						color: '#FF1209'
					}
				}
				return {
					text: 'Otro',
					color: 'grey'
				}
			}
		},
		getUserName(history){
			const user = history.user
			if(user?.profile){
				return user.profile.name + ' ' + user.profile.lastname + ' ' + user.profile.second_lastname	
			}
			return '';
		},
		closeModal() {
			this.menuOpen = false;
		}
	}
};
</script>

<style scoped>
	.contract-annulation-info-container{
		background-color: white;
		max-width: 450px;
		min-width: 350px;
		padding: 10px;
		border: 1px solid grey;
		opacity: 1!important;
	}
</style>